import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccueilComponent } from './accueil/accueil.component';
import { PresentationComponent } from './presentation/presentation.component';
import { PrestationComponent } from './prestation/prestation.component';
import { MaterielComponent } from './materiel/materiel.component';
import { ReferenceComponent } from './reference/reference.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { GalerieComponent } from './galerie/galerie.component';
import { EquipeComponent } from './equipe/equipe.component';
import { ProgrammationComponent } from './programmation/programmation.component';


const routes: Routes = [
  {
    path:'', 
    component:AccueilComponent
  },
  {
    path:'presentation',
    component:PresentationComponent
  },
  {
    path:'prestation',
    component:PrestationComponent
  },
  {
    path:'materiel',
    component:MaterielComponent
  },
  {
    path:'reference',
    component:ReferenceComponent
  },
  {
    path:'contact',
    component:ContactComponent
  },
  {
    path:'galerie',
    component:GalerieComponent
  },
  {
    path:'equipe',
    component: EquipeComponent
  },
  {
    path:'programmation',
    component:ProgrammationComponent
  },
  {
    path:'**',
    component:PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageRoutingModule { }
